import config from '../../config';

export default {
  url: `${
    config.api.baseURL
  }/accounts/:accountId/profiles/:profileId/progress/:chapterId/:topicId`,
  transformer(data) {
    return data;
  }
};
